import { Actions } from './commercial-license-mappings.actions'
import { fromJS } from 'immutable'
import * as commercialLicenseMappingTypes from './commercial-license-mappings.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
  },
  createCommercialLicenseMapping: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateCommercialLicenseMapping: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function commercialLicenseMappingsReducer(
  state = initialState,
  action: Actions,
) {
  switch (action.type) {
    case commercialLicenseMappingTypes.UPDATE_COMMERCIAL_LICENSE_MAPPING_REQUEST: {
      return state.setIn(['updateCommercialLicenseMapping', 'isLoading'], true)
    }

    case commercialLicenseMappingTypes.UPDATE_COMMERCIAL_LICENSE_MAPPING_SUCCESS: {
      return state.setIn(['updateCommercialLicenseMapping', 'isLoading'], false)
    }

    case commercialLicenseMappingTypes.UPDATE_COMMERCIAL_LICENSE_MAPPING_FAILURE: {
      return state.setIn(['updateCommercialLicenseMapping', 'isLoading'], false)
    }

    case commercialLicenseMappingTypes.CREATE_COMMERCIAL_LICENSE_MAPPING_REQUEST: {
      return state.setIn(['createCommercialLicenseMapping', 'isLoading'], true)
    }

    case commercialLicenseMappingTypes.CREATE_COMMERCIAL_LICENSE_MAPPING_SUCCESS: {
      return state.setIn(['createCommercialLicenseMapping', 'isLoading'], false)
    }

    case commercialLicenseMappingTypes.CREATE_COMMERCIAL_LICENSE_MAPPING_FAILURE: {
      return state.setIn(['createCommercialLicenseMapping', 'isLoading'], false)
    }

    case commercialLicenseMappingTypes.DELETE_COMMERCIAL_LICENSE_MAPPING_REQUEST: {
      return state
    }

    case commercialLicenseMappingTypes.DELETE_COMMERCIAL_LICENSE_MAPPING_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case commercialLicenseMappingTypes.DELETE_COMMERCIAL_LICENSE_MAPPING_FAILURE: {
      return state
    }

    case commercialLicenseMappingTypes.FETCH_COMMERCIAL_LICENSE_MAPPINGS_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case commercialLicenseMappingTypes.FETCH_COMMERCIAL_LICENSE_MAPPINGS_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
    }

    case commercialLicenseMappingTypes.FETCH_COMMERCIAL_LICENSE_MAPPINGS_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case commercialLicenseMappingTypes.ORDER_COMMERCIAL_LICENSE_MAPPINGS_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case commercialLicenseMappingTypes.ORDER_COMMERCIAL_LICENSE_MAPPINGS_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
    }

    case commercialLicenseMappingTypes.ORDER_COMMERCIAL_LICENSE_MAPPINGS_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case commercialLicenseMappingTypes.FETCH_COMMERCIAL_LICENSE_MAPPING_REQUEST: {
      return state.setIn(['updateCommercialLicenseMapping', 'isLoading'], true)
    }

    case commercialLicenseMappingTypes.FETCH_COMMERCIAL_LICENSE_MAPPING_SUCCESS: {
      return state
        .setIn(['updateCommercialLicenseMapping', 'isLoading'], false)
        .setIn(
          ['updateCommercialLicenseMapping', 'data'],
          fromJS(action.payload),
        )
    }

    case commercialLicenseMappingTypes.FETCH_COMMERCIAL_LICENSE_MAPPING_FAILURE: {
      return state.setIn(['updateCommercialLicenseMapping', 'isLoading'], false)
    }

    case commercialLicenseMappingTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case commercialLicenseMappingTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
